'use strict';

import React, { Component } from 'react';

import MapSearch from '../components/menuComponents/MapSearch';
import InfoComponent from '../components/menuComponents/InfoComponent';
import ListComponent from '../components/menuComponents/ListComponent';
import CollectionsListComponent from '../components/menuComponents/CollectionsListComponent';

import classNames from 'classnames';

class MapMenuContainer extends Component {
  constructor(props) {
    super(props);

    this.handleLocationBtnClick = this.handleLocationBtnClick.bind(this);
  }

  handleMenuBtnClicked(tabIndex) {
    this.props.handleMenuTabClick(tabIndex);
  }

  handleLocationBtnClick() {
    this.buttonDOM.blur();
    this.props.handleMyLocationClick(true);
  }

  render() {
    const { menuStatus } = this.props;
    const menuClasses = classNames('map-menu', {
      'map-menu--toggle': menuStatus
    });

    const btnInfoClasses = classNames('btn', {
      'btn--active': this.props.activeMenuTab === 'tabInfo'
    });

    const btnMapClasses = classNames('btn', {
      'btn--active': this.props.activeMenuTab === 'tabMap'
    });

    const btnListClasses = classNames('btn', {
      'btn--with-counter': this.props.events.length > 0,
      'btn--active': this.props.activeMenuTab === 'tabList'
    });

    const btnFilterClasses = classNames('btn', {
      'btn--active': this.props.activeMenuTab === 'tabFilter'
    });

    return (
      <div className={menuClasses}>
        <div className="map__panel-controls">
          <button type="button" className={btnInfoClasses} onClick={() => this.handleMenuBtnClicked('tabInfo')}>
            <span>Info</span>
          </button>
          <button type="button" className={btnMapClasses} onClick={() => this.handleMenuBtnClicked('tabMap')}>
            <span>Map</span>
          </button>
          <button type="button" className={btnListClasses} onClick={() => this.handleMenuBtnClicked('tabList')}>
            <span>Events</span>
            {this.props.events.length > 0 && (<span className="counter-text">{this.props.events.length}</span>)}
          </button>
          <button type="button" style={{ display: 'none' }} className={btnFilterClasses} onClick={() => this.handleMenuBtnClicked('tabFilter')}>
            <span>Filter</span>
          </button>
        </div>

        <div className="map-utilities">
          <div className="map-data-info">
            <span>Last update: </span>
            <span>{this.props.collLastUpdated}</span>
          </div>
          <div className="map-data-info map-data-info--bottom">
            <span>Last update: </span>
            <span>{this.props.collLastUpdated}</span>
          </div>
          <MapSearch
            mapApiRef={this.props.mapApiRef}
            handleSearch={this.props.handleSearch}
          />
          <button type="button" className="btn btn--location" onClick={this.handleLocationBtnClick} ref={(buttonDOM) => { this.buttonDOM = buttonDOM; }}>
            Use My Location
          </button>
        </div>

        <div className="map-menu__control-btns">
          <button type="button" className="btn--toggle-menu-desktop" onClick={this.props.handleMenuToggleClick}>
            <span className="btn--toggle-menu__part"></span>
            <span className="btn--toggle-menu__part"></span>
            <span className="btn--toggle-menu__part"></span>
            <span className="btn--toggle-menu__text">Menu</span>
          </button>
          <button type="button" className="btn--toggle-menu-mobile" onClick={this.props.handleMenuToggleClick}>
            <span className="text--hide-filters">Hide Map Filters</span>
            <span className="text--show-filters">Show Map Filters</span>
          </button>
        </div>
        <div className="map-menu-panels">
          {this.props.activeMenuTab === 'tabInfo' && <InfoComponent htmlContent={this.props.tabInfoContent} />}
          {this.props.activeMenuTab === 'tabList' &&
            <ListComponent
              events={this.props.events}
              mapRef={this.props.mapRef}
              mapApi={this.props.mapApiRef}
              selectedSortOption={this.props.selectedSortOption}
              handleEventsSort={this.props.handleEventsSort}
              handleMenuTabClick={this.props.handleMenuTabClick}
            />
          }
          {this.props.activeMenuTab === 'tabFilter' &&
            <CollectionsListComponent
              selectedCollection={this.props.selectedCollection}
              handleCollectionSelected={this.props.handleCollectionSelected}
            />
          }
        </div>
      </div>
    );
  }
}

export default MapMenuContainer;